import { Auth } from "aws-amplify";
import { Utils } from "../utils/utils";
import Binance from "binance-api-node";
const client = Binance();

// const BASE = "https://syxcae0rpi.execute-api.eu-west-1.amazonaws.com/dev";
// const BASE = "https://r8l7gw70c2.execute-api.eu-west-1.amazonaws.com/qa";

// Production URLs
// const BASE = "https://v4jp0z17dg.execute-api.eu-west-1.amazonaws.com/qa";
// const HEAT_MAP_BASE =
//   "https://f70vdw03mj.execute-api.eu-west-1.amazonaws.com/production";

// Staging 1 URLs
// const BASE = "https://7iq4m6ic63.execute-api.eu-west-1.amazonaws.com/qa";
// const HEAT_MAP_BASE =
//   "https://v910apa6u8.execute-api.eu-west-1.amazonaws.com/staging-1";

// Crypto URLs
const BASE = "https://s1yo2g3l5d.execute-api.eu-west-1.amazonaws.com/qa";
const HEAT_MAP_BASE =
  "https://i8k2hjtaoj.execute-api.eu-west-1.amazonaws.com/crypto";

export class Api {
  static fetchGetRequestWithToken(path, URL = BASE) {
    return fetch(URL + path, {
      headers: {
        Authorization: "7b5e5059f6a973b5681f63f36730c5",
      },
    })
      .then((res) => (res.status < 400 ? res : Promise.reject(res)))
      .then((res) => res.json())
      .catch((err) => {
        return;
      });
  }

  static fetchPostRequestWithToken(path, data) {
    return fetch(BASE + path, {
      method: "POST",
      headers: {
        Authorization: "7b5e5059f6a973b5681f63f36730c5",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => (res.status < 400 ? res : Promise.reject(res)))
      .then((res) => res.json())
      .catch((err) => console.log(err));
  }

  static fetchFileUploadWithToken(path, data) {
    return fetch(BASE + path, {
      method: "POST",
      headers: {
        Authorization: "7b5e5059f6a973b5681f63f36730c5",
      },
      body: data,
    })
      .then((res) => res.json())
      .catch((err) => console.log(err));
  }

  static fetchPutRequestWithToken(path, data) {
    return fetch(BASE + path, {
      method: "PUT",
      headers: {
        Authorization: "7b5e5059f6a973b5681f63f36730c5",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => (res.status < 400 ? res : Promise.reject(res)))
      .then((res) => res.json())
      .catch((err) => console.log(err));
  }

  static fetchPatchRequestWithToken(path, data) {
    return fetch(BASE + path, {
      method: "PATCH",
      headers: {
        Authorization: "7b5e5059f6a973b5681f63f36730c5",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => (res.status < 400 ? res : Promise.reject(res)))
      .catch((err) => console.log(err));
  }

  static fetchDeleteRequestWithToken(path) {
    return fetch(BASE + path, {
      method: "DELETE",
      headers: {
        Authorization: "7b5e5059f6a973b5681f63f36730c5",
      },
    })
      .then((res) => (res.status < 400 ? res : Promise.reject(res)))
      .catch((err) => console.log(err));
  }

  static getCharts() {
    let path = "/financial/v1/charts";

    return this.fetchGetRequestWithToken(path);
  }

  static logout() {
    return Auth.signOut();
  }

  static getChart(id, resampleSize, intervalString) {
    let path = "/financial/v1/charts/" + id;

    if (resampleSize) {
      path += "?resample_size=" + resampleSize;
    }

    return this.fetchGetRequestWithToken(path)
      .then((data) => {
        const chartData = {
          id: data.id,
          name: data.name,
          interval: data.interval,
          intervalString,
        };
        const bars = data.bars.map((bar) => ({
          time: Utils.convertDatetimeToTimestamp(bar.datetime),
          open: bar.open,
          high: bar.high,
          low: bar.low,
          close: bar.close,
          volume: bar.volume,
        }));
        return { chartData, bars };
      })
      .catch((e) => {
        console.log(e);
        return;
      });
  }
  static getBinanceChart(id, interval) {
    const [symbol, intervalString] = id.split("_");
    return client
      .candles({
        symbol,
        interval: intervalString,
        limit: 1000,
      })
      .then((data) => {
        const chartData = {
          id: id,
          name: symbol,
          interval,
          intervalString,
          type: "Binance",
        };
        const bars = data.map((bar) => ({
          time: bar.openTime,
          open: +bar.open,
          high: +bar.high,
          low: +bar.low,
          close: +bar.close,
          volume: +bar.volume,
        }));
        return { chartData, bars };
      });
  }

  static getModels() {
    let path = "/financial/v1/models";

    return this.fetchGetRequestWithToken(path);
  }

  static createModel(data) {
    let path = "/financial/v1/models";

    return this.fetchPostRequestWithToken(path, data);
  }

  static createColdModel(data) {
    let path = "/financial/v1/models/cold-training";

    return this.fetchPostRequestWithToken(path, data);
  }

  static trainModel(id, data) {
    let path = "/financial/v1/models/" + id;

    return this.fetchPutRequestWithToken(path, data);
  }

  static coldTrainModel(id, data) {
    let path = "/financial/v1/models/" + id + "/cold-training";

    return this.fetchPutRequestWithToken(path, data);
  }

  static editModel(id, data) {
    let path = "/financial/v1/models/" + id;

    return this.fetchPatchRequestWithToken(path, data);
  }

  static removeModel(id) {
    let path = "/financial/v1/models/" + id;

    return this.fetchDeleteRequestWithToken(path);
  }

  static detectPatternsWithoutData({
    modelId,
    chartId,
    use_model_confidence_threshold,
    max_number,
  }) {
    const path = `/financial/v1/detection/models/${modelId}/charts/${chartId}?use_model_confidence_threshold=${use_model_confidence_threshold}&max_number=${max_number}`;

    return this.fetchGetRequestWithToken(path);
  }
  static detectPatternsWithData(payload) {
    let path = `/financial/v1/detection/models/${payload.modelId}`;
    return this.fetchPostRequestWithToken(path, payload);
  }

  static getModel(id) {
    let path = "/financial/v1/models/" + id;

    return this.fetchGetRequestWithToken(path);
  }

  static getChartCollections() {
    let path = "/financial/v1/chart-collections";

    return this.fetchGetRequestWithToken(path);
  }
  static getChartCollection(id) {
    let path = "/financial/v1/chart-collections/" + id;

    return this.fetchGetRequestWithToken(path);
  }

  static detectPatternsOnCollection(modelId, collectionId) {
    let path =
      "/financial/v1/detection/models/" +
      modelId +
      "/chart-collections/" +
      collectionId;

    return this.fetchGetRequestWithToken(path);
  }

  static uploadNewChart(data) {
    let path = "/financial/v1/charts/upload-csv";

    return this.fetchFileUploadWithToken(path, data);
  }

  static deleteChart(id) {
    let path = "/financial/v1/charts/" + id;

    return this.fetchDeleteRequestWithToken(path);
  }

  static viewChartDetails(id) {
    let path = "/financial/v1/charts/" + id;

    return this.fetchGetRequestWithToken(path);
  }

  static viewChartCollectionDetails(id) {
    let path = `/financial/v1/chart-collections/${id}`;
    return this.fetchGetRequestWithToken(path);
  }

  static getIndicatorList() {
    const path = "/financial/v1/indicators";

    return this.fetchGetRequestWithToken(path);
  }

  static getIndicators({ indicators, chartId }) {
    const path = `/financial/v1/indicators/${indicators.join(
      ","
    )}/charts/${chartId}`;
    return this.fetchGetRequestWithToken(path);
  }

  static getHeatMapPatterns(interval, modelId) {
    const path = `/signals/patterns/intervals/${interval}/models/${modelId}`;

    return this.fetchGetRequestWithToken(path, HEAT_MAP_BASE);
  }

  static getHeatMapIndicators(interval) {
    const path = `/signals/indicators/intervals/${interval}`;

    return this.fetchGetRequestWithToken(path, HEAT_MAP_BASE);
  }

  static getHeatMapModelIds() {
    const path = "/signals/models";

    return this.fetchGetRequestWithToken(path, HEAT_MAP_BASE);
  }
}
